// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3dBiA","author":"Table_author__1psiW","authorImage":"Table_authorImage__1vc23","unreadRow":"Table_unreadRow__XK8_d"};